// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

/* Global font family */
html, body {
  font-family: 'Urbanist', sans-serif;
  margin: 0;
  padding: 0;
  overflow-x: hidden; /* Prevent horizontal scrolling */
  background-color: var(--bg-base);
  color: var(--text-primary);
}

/* Reset some basic styling */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.App {
  background-color: var(--bg-base);
  color: var(--text-primary);
  min-height: 100vh;
  min-height: 100dvh;
}

.vertical-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  width: 100%;
  background-color: transparent;
}

/* Content column sits above the fixed ambient backdrop */
.horizontal-container {
  position: relative;
  z-index: 1;
  display: flex;
  flex: 1;
  background-color: transparent;
  font-family: 'Urbanist', sans-serif;
  overflow: hidden;
  width: 100%;
  gap: var(--layout-gap);
  padding: 0;
  min-height: 0;
}

.horizontal-container--no-sidebar .app-main {
  max-width: none;
  margin: 0;
}

/* Full-bleed scroll area; content itself stays in a readable centered column */
.app-main {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: var(--space-7) var(--layout-outer) var(--space-8);
  scrollbar-color: var(--border-strong) transparent;
}

/* Homepage is a single viewport composition — never scroll the shell. */
.app-main:has(.orbit-page) {
  overflow: hidden;
  padding-bottom: 0;
}

.app-main > * {
  width: 100%;
  max-width: var(--layout-page-max);
  margin-inline: auto;
}

/* Legacy inset surface — now a transparent pass-through so pages read as
   part of the full-bleed screen. Kept for any page still rendering it. */
.app-content-surface {
  width: 100%;
  background-color: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .horizontal-container {
    gap: 0;
  }

  .app-main {
    padding: var(--space-6) var(--space-4) var(--space-7);
  }

  .app-main:has(.orbit-page) {
    padding-bottom: 0;
  }
}

@media (max-width: 768px) {
  .horizontal-container {
    gap: 0;
  }

  .app-main {
    padding: var(--layout-page-pad-mobile);
    padding-top: calc(56px + var(--space-5)); /* Fixed topbar */
    padding-bottom: var(--space-8);
    width: 100%;
  }

  .app-main:has(.orbit-page) {
    /* Only clear the fixed topbar; the dial lives in-flow at the bottom. */
    padding: 56px var(--layout-page-pad-mobile) 0;
    overflow: hidden;
  }

  .vertical-container {
    width: 100%;
  }
}

.full-page-layout {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  background-color: var(--bg-base);
  color: var(--text-primary);
}

.full-page-layout-content {
  position: relative;
  z-index: 1;
}

.auth-callback-screen {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: var(--text-primary);
}

.auth-callback-message {
  position: relative;
  z-index: 1;
  font-size: 18px;
}

/* Dark scrollbars so the shell stays seamless */
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--border-strong);
  border: 3px solid transparent;
  background-clip: content-box;
  border-radius: 999px;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.28);
  background-clip: content-box;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,uBAAuB;AACvB;EACE,mCAAmC;EACnC,SAAS;EACT,UAAU;EACV,kBAAkB,EAAE,iCAAiC;EACrD,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,WAAW;EACX,6BAA6B;AAC/B;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,OAAO;EACP,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;EAC1D,iDAAiD;AACnD;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;yEACyE;AACzE;EACE,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;IACE,MAAM;EACR;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,MAAM;EACR;;EAEA;IACE,sCAAsC;IACtC,wCAAwC,EAAE,iBAAiB;IAC3D,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,uEAAuE;IACvE,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B","sourcesContent":["/* App.css */\n\n/* Global font family */\nhtml, body {\n  font-family: 'Urbanist', sans-serif;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden; /* Prevent horizontal scrolling */\n  background-color: var(--bg-base);\n  color: var(--text-primary);\n}\n\n/* Reset some basic styling */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.App {\n  background-color: var(--bg-base);\n  color: var(--text-primary);\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\n.vertical-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh;\n  width: 100%;\n  background-color: transparent;\n}\n\n/* Content column sits above the fixed ambient backdrop */\n.horizontal-container {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex: 1;\n  background-color: transparent;\n  font-family: 'Urbanist', sans-serif;\n  overflow: hidden;\n  width: 100%;\n  gap: var(--layout-gap);\n  padding: 0;\n  min-height: 0;\n}\n\n.horizontal-container--no-sidebar .app-main {\n  max-width: none;\n  margin: 0;\n}\n\n/* Full-bleed scroll area; content itself stays in a readable centered column */\n.app-main {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: var(--space-7) var(--layout-outer) var(--space-8);\n  scrollbar-color: var(--border-strong) transparent;\n}\n\n/* Homepage is a single viewport composition — never scroll the shell. */\n.app-main:has(.orbit-page) {\n  overflow: hidden;\n  padding-bottom: 0;\n}\n\n.app-main > * {\n  width: 100%;\n  max-width: var(--layout-page-max);\n  margin-inline: auto;\n}\n\n/* Legacy inset surface — now a transparent pass-through so pages read as\n   part of the full-bleed screen. Kept for any page still rendering it. */\n.app-content-surface {\n  width: 100%;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n@media (max-width: 1024px) {\n  .horizontal-container {\n    gap: 0;\n  }\n\n  .app-main {\n    padding: var(--space-6) var(--space-4) var(--space-7);\n  }\n\n  .app-main:has(.orbit-page) {\n    padding-bottom: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .horizontal-container {\n    gap: 0;\n  }\n\n  .app-main {\n    padding: var(--layout-page-pad-mobile);\n    padding-top: calc(56px + var(--space-5)); /* Fixed topbar */\n    padding-bottom: var(--space-8);\n    width: 100%;\n  }\n\n  .app-main:has(.orbit-page) {\n    /* Only clear the fixed topbar; the dial lives in-flow at the bottom. */\n    padding: 56px var(--layout-page-pad-mobile) 0;\n    overflow: hidden;\n  }\n\n  .vertical-container {\n    width: 100%;\n  }\n}\n\n.full-page-layout {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  overflow: auto;\n  background-color: var(--bg-base);\n  color: var(--text-primary);\n}\n\n.full-page-layout-content {\n  position: relative;\n  z-index: 1;\n}\n\n.auth-callback-screen {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  color: var(--text-primary);\n}\n\n.auth-callback-message {\n  position: relative;\n  z-index: 1;\n  font-size: 18px;\n}\n\n/* Dark scrollbars so the shell stays seamless */\n*::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--border-strong);\n  border: 3px solid transparent;\n  background-clip: content-box;\n  border-radius: 999px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(255, 255, 255, 0.28);\n  background-clip: content-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
